module.exports = __webpack_public_path__ + "img/article_image.589ea0f.jpg";